export type FulfillmentType = 'pickup' | 'delivery';

export interface DeliveryAddress {
  street: string;
  city: string;
  state: string;
  zip: string;
  country?: string;
  instructions?: string;
  phone?: string;
}

export interface DeliveryQuoteResult {
  success: boolean;
  deliveryFeeCents: number;
  serviceFeeCents: number;
  deliveryAndFeesCents: number;
  tipCents: number;
  subtotalCents: number;
  totalCents: number;
  etaMinutes: number;
  quoteExternalDeliveryId?: string;
  mockQuote?: boolean;
  error?: string;
}

export interface DeliveryCheckoutIntents {
  success: boolean;
  orderId: string;
  subtotalCents: number;
  deliveryFeeCents: number;
  serviceFeeCents: number;
  deliveryAndFeesCents: number;
  tipCents: number;
  totalCents: number;
  foodClientSecret: string;
  foodPaymentIntentId: string;
  logisticsClientSecret: string;
  logisticsPaymentIntentId: string;
  stripeConnectAccountId?: string;
  error?: string;
}

export interface MerchantDeliverySettings {
  deliveryEnabled: boolean;
  deliveryPickupAddress: string;
  deliveryPickupPhone: string;
  doordashStoreId: string;
}

export const DEFAULT_MERCHANT_DELIVERY_SETTINGS: MerchantDeliverySettings = {
  deliveryEnabled: false,
  deliveryPickupAddress: '',
  deliveryPickupPhone: '',
  doordashStoreId: '',
};

export function parseMerchantDeliverySettings(
  data: Record<string, unknown> | null | undefined
): MerchantDeliverySettings {
  if (!data) return { ...DEFAULT_MERCHANT_DELIVERY_SETTINGS };
  return {
    deliveryEnabled: data.deliveryEnabled === true,
    deliveryPickupAddress:
      typeof data.deliveryPickupAddress === 'string' ? data.deliveryPickupAddress : '',
    deliveryPickupPhone:
      typeof data.deliveryPickupPhone === 'string' ? data.deliveryPickupPhone : '',
    doordashStoreId: typeof data.doordashStoreId === 'string' ? data.doordashStoreId : '',
  };
}

export function formatDeliveryAddressLine(addr: DeliveryAddress): string {
  const parts = [addr.street, addr.city, addr.state, addr.zip, addr.country].filter(Boolean);
  return parts.join(', ');
}

export function formatCentsUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}
